<template>
    <div id="app">
        <v-app id="inspire">
            <v-layout row wrap>
                <v-flex>
                    <v-container>
                        <v-stepper v-model="e1">
                            <v-stepper-header class="blue-grey darken-3">
                                <v-stepper-step color="green darken-2" :complete="e1 > 1" step="1">
                                    <span class="white--text">Customer Details</span>
                                </v-stepper-step>
                        
                                <v-divider></v-divider>
                        
                                <v-stepper-step color="green darken-2" :complete="e1 > 2" step="2" >
                                    <span class="white--text">Services</span>
                                </v-stepper-step>
                        
                                <v-divider></v-divider>
                        
                                <v-stepper-step color="green darken-2" :complete="e1 > 3" step="3" >
                                    <span class="white--text">Schedule</span>
                                </v-stepper-step>

                                <v-divider></v-divider>
                        
                                <v-stepper-step color="green darken-2" :complete="e1 > 3" step="4" >
                                    <span class="white--text">Review Appointment</span>
                                </v-stepper-step>
                            </v-stepper-header>
                        
                            <v-stepper-items class="grey lighten-5">
                                <v-stepper-content step="1">
                                    <v-layout>
                                        <v-flex xs6 class="pl-3" v-if="!customer.fullName"> 
                                            <v-btn right color="deep-orange" large outline @click="newCustomerDialog=true">NEW CUSTOMER</v-btn>
                                            <br>
                                        </v-flex>

                                        <v-flex xs6 class="pl-3" v-else> 
                                            <v-btn right color="deep-orange" large outline @click="customer={}">SELECT CUSTOMER</v-btn>
                                        </v-flex>

                                        <v-flex xs6 v-if="!customer.fullName">
                                            <v-spacer></v-spacer>
                                            <v-text-field class="subheading font-weight-regular" flat v-model="search" append-icon="search" label="Search" single-line hide-details v-on:keyup.enter="searchCustomer(search)"></v-text-field>
                                            <br>
                                        </v-flex>
                                        <v-flex xs6 v-else></v-flex>
                                    </v-layout>

                                    <v-layout>  
                                        <v-flex xs12 v-if="!customer.fullName">
                                            <v-data-table :headers="customerHeaders" :items="customers">
                                                <template v-slot:items="props">
                                                    <td>{{ props.item.fullName }}</td>
                                                    <td class="text-xs-center">{{ props.item.email }}</td>
                                                    <td class="text-xs-center">+63{{ props.item.mobileNumber }}</td>
                                                    <td class="text-xs-center">{{ props.item.address.brgy }} {{ props.item.address.city }} {{ props.item.address.state }}</td>
                                                    <td class="justify-center layout px-0">
                                                        <v-btn color="blue darken-4" dark small outline @click="selectedCustomer(props.item)">Select</v-btn>
                                                    </td>
                                                </template>
                                                <template v-slot:no-results>
                                                    <v-alert :value="true" color="error" icon="warning">
                                                        Your search for "{{ search }}" found no results.
                                                    </v-alert>
                                                </template>
                                            </v-data-table>
                                        </v-flex>
                                        <v-flex xs12 v-else>
                                        </v-flex>
                                    </v-layout>
                                    
                                    <v-layout v-if="customer.fullName">
                                        <v-layout>
                                            <v-flex xs6 class="pl-3">
                                                <v-card-title class="headline font-weight-black pb-0"> 
                                                    {{customer.fullName}}
                                                </v-card-title>

                                                <v-card-title v-if="customer.email!=''" class="subheading font-weight-medium pt-0 pb-0"> 
                                                    {{customer.email}}
                                                </v-card-title>

                                                <v-card-title v-if="customer.mobileNumber!=''" class="subheading font-weight-medium pt-0 pb-0"> 
                                                    +63{{customer.mobileNumber}}
                                                </v-card-title>

                                                <v-card-title class="subheading font-weight-medium pt-0 pb-0"> 
                                                    {{customer.address.brgy}} {{customer.address.city}} {{customer.address.state}}
                                                </v-card-title>
                                            </v-flex>

                                            <v-flex xs6>
                                                <v-flex xs12> 
                                                    <v-btn color="primary" outline @click="newCustomerDialog=true, showMotorcycleOnly=true">Add Motorcycle</v-btn>
                                                </v-flex><br>

                                                <v-flex xs12>
                                                    <v-combobox class="pt-0 pb-3" label="Select your motorcycle*" required hide-details  v-model="mcUnit" :items="mcOwned"
                                                    ></v-combobox>
                                                </v-flex>

                                                <v-layout v-if="mcUnit">
                                                    <v-flex xs12>
                                                        <v-text-field label="Last Mileage(km)" class="pt-0" v-model="oldOdo" hide-details readonly></v-text-field>
                                                    
                                                        <v-text-field label="Current Mileage(km)*" hide-details v-model="odometer"></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-layout>

                                    <v-container text-xs-right>
                                        <v-btn color="blue accent-4" class="white--text" @click="mcValidation()"> Next </v-btn>
                                    </v-container>
                                </v-stepper-content>
                        
                                <v-stepper-content step="2">
                                    <v-layout wrap>
                                        <v-flex xs6>
                                            <v-card-title class="justify-center title font-weight-bold pb-0 pt-4">SERVICE MENU
                                            </v-card-title>
                                            <v-container grid-list-sm fluid>
                                                <v-layout row wrap>
                                                    <v-flex xs12 v-for="service in serviceMenu" :key="service.id" class="pt-0 pl-3">
                                                        <v-checkbox class="pa-0" type="checkbox" :label="service.serviceName" v-model="selected.service" :value="service"/>
                                                        <v-card-title class="caption font-weight-regular pt-0">{{service.description}}
                                                        </v-card-title>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-flex>
                                        
                                        <v-flex xs6 class ="pt-3">
                                            <v-container grid-list-sm fluid>
                                                <v-layout v-for="(list,index) in otherServices" :key="index">
                                                    <v-flex xs7>
                                                        <v-text-field v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required
                                                        prepend-icon="cancel" @click:prepend="removeOtherService(index)"></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs4>
                                                        <v-select v-model="otherServices[index].time" :items="otherTimeRate" label="Time Rate(minutes)" required
                                                        > </v-select>
                                                    </v-flex>
                                                </v-layout>

                                                <v-flex xs12 class="pl-0"><v-btn outline dark color="blue darken-4" @click="addOtherServices()">Add Other Services</v-btn></v-flex>
                                            </v-container>

                                            <v-container text-xs-center>
                                                <v-layout class="justify-center">
                                                    <v-flex xs12>
                                                    <v-btn color="red accent-4" class="white--text" @click="e1=1">Back</v-btn>
                                                    <v-btn color="blue accent-4" class="white--text" @click="(serviceValidation(),setServices(),chargeEstimate())"> Next </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-flex>
                                    </v-layout>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                    <v-container>
                                        <v-layout>
                                            <v-flex xs7>
                                            <div>
                                                <v-date-picker v-model="calendar" header-color="red" full-width class="mt-3" :min="date" :max="maximumDate" :allowed-dates="allowedDates" :events="arrayEvents" event-color="red">
                                                </v-date-picker>
                                            </div>
                                            <br>
                                                
                                            <v-layout justify-center>
                                            <v-btn color="red accent-4" class="white--text" @click="e1=2">Back</v-btn>
                                            <v-btn color="blue accent-4" class="white--text" @click="(scheduleValidation(),timeUpdate())"> Next </v-btn>
                                            </v-layout>
                                            </v-flex>

                                            <v-flex xs5>
                                                <v-container grid-list-md text-xs-center>
                                                <v-layout row wrap v-if="!arrayEvents.includes(calendar)">
                                                    <v-flex xs12><v-combobox v-model="mechanic" :items="mechanics" label="Select Mechanic" hide-details></v-combobox></v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-0">AM
                                                        </v-card-title>
                                                        <v-radio-group v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am')" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-2">PM
                                                        </v-card-title>
                                                        <v-radio-group v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm')" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-stepper-content>

                                <v-stepper-content step="4">    
                                    <v-flex xs12 md12 lg12>
                                        <v-card-title height=10 class="justify-center display-1 font-weight-black">APPOINTMENT SUMMARY
                                        </v-card-title>
                                    </v-flex>

                                    <v-container>
                                        <v-layout wrap>
                                            <v-flex xs12 md6 lg6>
                                                <v-card-title class="subtitle-2 font-weight-black pb-2"> 
                                                    Work Requested
                                                </v-card-title>
                                                <div v-for="card in initialService" :key="card.id">
                                                    <v-card-title class="title font-weight-black pb-0 pt-0"> 
                                                        {{card.displayName}}
                                                    </v-card-title>
                                                </div>
                                            </v-flex>
                         
                                            <v-flex xs12 md6 lg6>
                                                <v-card-title class="subtitle-2 font-weight-black pb-0"> 
                                                    {{customer.fullName}}
                                                </v-card-title>

                                                <v-card-title class="subtitle-2 font-weight-bold pb-0 pt-0"> 
                                                    {{customer.email}} | +63{{customer.mobileNumber}} 
                                                </v-card-title>

                                                <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                    {{branch}}
                                                </v-card-title>

                                                <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                    {{computedDateFormattedMomentjs}}
                                                </v-card-title>

                                                <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                    {{schedtime}}
                                                </v-card-title>

                                                <v-divider></v-divider>

                                                <v-layout wrap class="justify-center">
                                                    <v-btn dark color="red accent-4" @click="cancelDialog=true">Cancel</v-btn>
                                                    <v-btn dark color="blue accent-4" @click="(generateId())"> Save </v-btn>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-container>
                </v-flex>

                <v-layout row justify-center >
                    <v-dialog v-model="cancelDialog" max-width="500px">
                        <v-card>
                            <v-card-title class="title font-weight-regular justify-center">
                                Are you sure you want to cancel application ? 
                            </v-card-title>
                            <v-card-actions class="justify-center">
                            <v-btn color="primary" flat @click="reload()">YES</v-btn>
                            <v-btn color="primary" flat @click="cancelDialog=false">NO</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-layout>

                <v-dialog v-model="newCustomerDialog" persistent max-width="80%">
                    <v-card>
                        <v-parallax dark class="blue-grey darken-3 pb-0" height="70">
                            <v-container>
                                <v-layout>
                                    <h4 v-if="showMotorcycleOnly" class="subheading font-weight-medium">NEW MOTORCYCLE</h4>
                                    <h4 v-else class="subheading font-weight-medium">NEW CUSTOMER</h4>
                                </v-layout>
                            </v-container>
                        </v-parallax> 

                        <v-card-text class="pt-0">
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs6 v-if="!showMotorcycleOnly">
                                        <v-flex xs12>
                                            <v-text-field v-model="firstName" hide-details label="First Name*"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="middleName" hide-details label="Middle Name"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="lastName" hide-details label="Last Name*"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="email" hide-details label="Email"></v-text-field>
                                        </v-flex>

                                        <v-layout>
                                            <v-flex xs3>
                                                <v-text-field label="Country Code" hide-details readonly type="text" required value="+63" ></v-text-field>
                                            </v-flex>
                                            <v-flex xs9>
                                                <v-text-field v-model="mobileNumber" hide-details :rules="mobileChecker" label="Mobile Number*" maxlength="10" type="text" required hint=" ex.9123456789"></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                        <h3 class="pl-0 pb-0 pt-5">ADDRESS</h3>
                                        <v-flex xs12>
                                            <v-text-field v-model="address.brgy" hide-details label="Barangay"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="address.city" hide-details label="City"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="address.state" hide-details label="Province"></v-text-field>
                                        </v-flex><br>

                                        <v-layout justify-center>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn dark color="red accent-4" @click="newCustomerDialog=false">Close</v-btn>
                                                <v-btn dark color="blue darken-4" @click="newCustomerValidation()">Save</v-btn>
                                            </v-card-actions>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex :xs6="!showMotorcycleOnly" :xs12="showMotorcycleOnly">
                                        <v-flex xs12 sm12 md12>
                                            <v-select v-model="dealer" label="Dealer/Store*" required :items="dealers" hide-details></v-select>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-select v-model="make" label="Make/Brand*" required
                                                :items="brands" hide-details
                                            ></v-select>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-select v-model="classification" label="Classification*" required
                                                :items="classifications" hide-details
                                            ></v-select>
                                        </v-flex>
                                    
                                        <v-flex xs12 sm12 md12>
                                            <v-text-field label="Model*" v-model="model" hide-details></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-menu ref="yearModelMenu" :close-on-content-click="false" v-model="yearModelMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                                <v-text-field slot="activator" v-model="yearModel" label="Year Model*" readonly hide-details></v-text-field>
                                                <v-date-picker ref="picker" :max="new Date().toISOString().substr(0, 10)" v-model="yearModel" @input="save" reactive no-title></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-text-field label="Color*" v-model="mcColor" hide-details
                                            ></v-text-field>
                                        </v-flex>
                                    
                                        <v-flex xs12 sm12 md12>
                                            <v-text-field label="Engine Number*" v-model="engineNumber" hide-details
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-text-field label="Chassis Number" v-model="chassisNumber" hide-details
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-text-field label="Plate Number*" v-model="plateNumber" hide-details
                                            ></v-text-field>
                                        </v-flex>
                                        
                                        <v-flex xs12 sm12 md12>
                                            <v-menu v-model="dateOfPurchaseMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-model="dateOfPurchase" label="Date of Purchase" readonly v-on="on" hide-details></v-text-field>
                                                </template>
                                                <v-date-picker v-model="dateOfPurchase" @input="dateOfPurchaseMenu=false"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-menu v-model="registrationDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-model="registrationDate" label="Registration Date" readonly v-on="on" hide-details></v-text-field>
                                                </template>
                                                <v-date-picker v-model="registrationDate" @input="registrationDateMenu=false"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-text-field label="Current Mileage(km)*" class="pb-2" v-model="odometer" hide-details
                                            ></v-text-field>
                                        </v-flex>

                                        <v-layout justify-center v-if="showMotorcycleOnly">
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn dark color="red accent-4" @click="newCustomerDialog=false, showMotorcycleOnly=false">Close</v-btn>
                                                <v-btn dark color="blue darken-4" @click="newMcValidation()">Save</v-btn>
                                            </v-card-actions>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import {db} from '../main'
import { mapGetters, mapState } from "vuex"
import { setTimeout } from 'timers'
import _ from 'lodash'
import moment from 'moment'
import Progress from '../extras/Progress.vue'
import Snackbar from '../extras/Snackbar.vue'
export default {
    components: {
        Snackbar,
        Progress
    },
    data() {
        return {
            branch: "",
            branchCode: "",
            e1: 1,
            timeout: 2000,
            allowedDates: null,
            date: moment().utcOffset('+0800').toISOString().substr(0, 10),
            maximumDate: moment().add(3, 'months').toISOString().substr(0, 10),
            headers: [
                { text: '', align: 'left', sortable: false,  value: '', width: '1%'},
                { text: 'Items for checking', align: 'left', sortable: false,  value: 'name'},
                { sortable: false, align: 'center', text: '', value: ''},
                { sortable: false, align: 'center', text: 'Estimated Price', value: 'price' },
            ],
            customerHeaders: [
                { text: 'Name', align: 'left', value: 'fullName'},
                { text: 'Email', value: 'email', sortable: false ,align: 'center'},
                { text: 'Mobile Number', value: 'mobileNumber', sortable: false, align: 'center'},
                { text: 'Address', value: 'address', sortable: false, align: 'center' },
                { text: 'Actions', value: 'name', sortable: false, align: 'center' }
            ],
            services: [],
            estimateCharge: 0,
            chargeHolder: [],
            timeHolder: [],
            estimateTime: 0,
            selected: { service: []},
            cancelDialog: false,
            calendar: moment().utcOffset('+0800').toISOString().substr(0, 10),
            times: [],
            timeDialog: false,
            schedtime: null,
            initialService: [],
            id: 0,
            removed: [],
            showServices: false,
            showCoupon: false,
            coupon: "",
            lists: [],
            laps: [],
            timeValidation: [],
            timeValidation2: [],
            timeRemoveHolder: [],
            timesChecker: [],
            arrayEvents: [],
            odometer: "",
            dateOfPurchase: null,
            dateOfPurchaseMenu: false,
            registrationDate: null,
            registrationDateMenu: false,
            oldOdo: "",
            mcOwned: [],
            mcLists: [],
            mcUnit: "",
            dealer: "",
            make: "",
            model: "",
            mcColor: "",
            yearModel: null,
            yearModelMenu: false,
            engineNumber: "",
            chassisNumber: "",
            dealers: [],
            brands: [],
            currentOdo: [],
            branchMechanics: [],
            mechanics: [],
            mechanic: "",  
            otherServices: [{
                service: "",
                price: 0,
                time: 0,
            }],
            plateNumber: "",
            timeObtain: [],
            transactions: [],
            selectedMc: null,
            bufferTime: 0,
            classifications: [],
            classification: "",
            serviceMenu: [],
            search: [],
            newCustomerDialog: false,
            showMotorcycleOnly: false,
            mobileNumber: "",
            mobileChecker: [v => v.length == 10|| 'Mobile number must be valid'],
            address: {
                brgy : "",
                city : "",
                state : ""
            },
            tin: "",
            fullName: "",
            firstName: "",
            middleName: "",
            lastName: "",
            email: "",
            customers: [],
            customer: {},
            newMcProfileDialog: false,
            otherTimeRate: [],
            branchId: "",
            snackbar: {
                responseMessage: "",
                show: false,
                type: "success"
            },
            progress: {
                message: "",
                show: false,
            },
        }
    },


    methods : {
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },
        async newCustomerValidation() {
            let self = this 
            if (self.firstName == "" || self.lastName == "") {
                self.showSnackbarMessage("Please fill-up customer name", false)
            } else if(self.mobileNumber.length != 10) {
                self.showSnackbarMessage("Mobile number must be valid", false)
            } else if (self.engineNumber === ""){
                self.showSnackbarMessage("Engine number should not be blank", false)
            } else if (self.plateNumber === "") {
                self.showSnackbarMessage("Plate number should not be blank", false)
            } else if (self.dealer === "") {
                self.showSnackbarMessage("Dealer should not be blank", false)
            } else if (self.make === "") {
                self.showSnackbarMessage("Make/Brand should not be blank", false)
            } else if (self.model === "") {
                self.showSnackbarMessage("Model should not be blank", false)
            } else if (self.odometer === "") {
                self.showSnackbarMessage("Please input current mileage(km)", false)
            } else if (self.yearModel === "" || self.yearModel === null) {
                self.showSnackbarMessage("Year model should not be blank", false)
            } else if (self.classification === "") {
                self.showSnackbarMessage("Classification should not be blank", false)
            }  else if (self.mcColor === "") {
                self.showSnackbarMessage("Color should not be blank", false)
            } else {
                await self.savePersonalDetais()
                self.newCustomerDialog = false
            }
        },
        async newMcValidation() {
            let self = this
            if (self.engineNumber === ""){
                self.showSnackbarMessage("Engine number should not be blank", false)
            } else if (self.plateNumber === "") {
                self.showSnackbarMessage("Plate number should not be blank", false)
            } else if (self.dealer === "") {
                self.showSnackbarMessage("Dealer should not be blank", false)
            } else if (self.make === "") {
                self.showSnackbarMessage("Make/Brand should not be blank", false)
            } else if (self.model === "") {
                self.showSnackbarMessage("Model should not be blank", false)
            } else if (self.odometer === "") {
                self.showSnackbarMessage("Please input current mileage(km)", false)
            } else if (self.yearModel === "" || self.yearModel === null) {
                self.showSnackbarMessage("Year model should not be blank", false)
            } else if (self.classification === "") {
                self.showSnackbarMessage("Classification should not be blank", false)
            } else if (self.mcColor === "") {
                self.showSnackbarMessage("Color should not be blank", false)
            } else {
                await self.saveMcDetails(self.customer.fullName,self.customer.email,self.customer.mobileNumber,"AddMcOnly")
                self.newCustomerDialog = false
                self.showMotorcycleOnly = false
            }
        },
        async savePersonalDetais() {
            let self = this
            let customerId = new Date().getTime().toString()
            await db.collection("WalkinCustomers"+self.$stage).doc(customerId).set({
                firstName: self.firstName,
                middleName: self.middleName,
                lastName: self.lastName,
                fullName: `${self.firstName} ${self.lastName}`,
                email: self.email,
                mobileNumber: self.mobileNumber,
                address: self.address,
                transactionId: "",
                status: "Pending",
                uid: customerId
            }).then(async function(res){
                await self.saveMcDetails(`${self.firstName} ${self.lastName}`, self.email, self.mobileNumber, "NewProfile")
                self.showSnackbarMessage("Customer Personal Information Saved", true)
            }).catch(function(error){
                console.log(error)
                self.showSnackbarMessage("Error saving Personal details", false)
            })
        },
        async saveMcDetails(owner,email,mobileNumber,type) {
            let self = this
            let timeStampId = new Date().getTime().toString()
            if (email === "") {
                email = "no.email"
            }
            await db.collection("McDetails"+self.$stage).doc(timeStampId).set({
                "owner": owner,
                "email": email,
                "mobile": mobileNumber,
                "classification": self.classification, 
                "dealer": self.dealer,
                "make": self.make,
                "model": self.model,
                "color": self.mcColor,
                "yearModel": self.yearModel,
                "engineNumber": self.engineNumber,
                "chassisNumber": self.chassisNumber,
                "plateNumber": self.plateNumber,
                "odometer": self.odometer,
                "dateOfPurchase": self.dateOfPurchase,
                "registrationDate": self.registrationDate,
                "transactions": self.transactions,
                "status": "1",
                "id": timeStampId
            }).then(function() {
                self.classification = ""
                self.dealer = ""
                self.make = ""
                self.model = ""
                self.yearModel = ""
                self.engineNumber = ""
                self.chassisNumber = ""
                self.odometer = ""
                self.plateNumber = ""
                self.dateOfPurchase = ""
                self.registrationDate = ""
                self.mcColor = ""
                self.transactions = []
                self.showSnackbarMessage("Customer Motorcycle Information Saved", true)
                setTimeout(() => {
                    if (type === "AddMcOnly"){
                        self.fetchMotorcycleDetails()
                    } else {
                        self.fetchCustomers()
                    }
                }, 500)
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Error saving Motorcycle details", false)
            })
        },
        async getAssign() {
            let self = this
            self.showProgress("Loading Mechanics...")
            await firebase.auth().onAuthStateChanged(async function(user) {
                await db.collection("Users"+self.$stage).doc(user.uid)
                .get().then(function(doc) {
                    self.branch = doc.data().assign.split('_')[1].trim()
                    self.branchCode = doc.data().assign.split('_')[0].trim()
                    self.branchId = doc.data().assignId
                }).then(async function() {
                    await self.fetchMechanics()
                    await self.calendarValidation()
                }).catch(function(error){
                    console.log(error)
                    self.showSnackbarMessage("Branch user access denied", false)
                })
            })
        },
        async fetchTimeSchedule(){
            let self = this
            let count = 0
            self.timesChecker = []
            await db.collection("Settings"+self.$stage).doc("Schedule")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    self.timesChecker.push(doc.data().time)
                    count ++
                    if (count === querySnapshot.docs.length) {
                        self.timesChecker.sort(function (timeA, timeB) {
                            return new Date('1970/01/01 ' + timeA) - new Date('1970/01/01 ' + timeB);
                        })
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Error in fetch time schedule", false)
            })
        },
        save(date) {
            this.$refs.yearModelMenu.save(date)
            this.$refs.picker.activePicker = "YEAR"
            this.yearModelMenu = false
        },
        async fetchClassification() {
            let self = this
            self.classifications = []
            await db.collection("Settings"+self.$stage).doc("Classification")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.showSnackbarMessage("Classification should be set", false)
                    } else {
                        self.classifications.push(doc.data().classification)
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Buffer time should be set", false)
            })
        },
        async fetchBufferTime() {
            let self = this
            await db.collection("Settings"+self.$stage).doc("BufferTime")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.bufferTime = 0
                        self.showSnackbarMessage("Buffer time should be set", false)
                    } else {
                        self.bufferTime = doc.data().time
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Buffer time should be set", false)
            })
        },
        async fetchMechanics() {
            let self = this
            self.branchMechanics = []
            self.mechanics = []
            await db.collection("Mechanics"+self.$stage)
            .where("status","==","Active")
            .where("branchId","==",self.branchId)
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc){
                    self.branchMechanics.push(doc.data())
                    self.mechanics.push(doc.data().name)
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Error fetching mechanics", false)
            })
        },
        chargeEstimate() {
            let self = this
            self.chargeHolder = []
            self.timeHolder = []
            self.initialService = []

            if (self.selectedMc.classification) {
                self.selected.service.forEach(function (result) {
                    result.classifications.forEach(function(data){
                        if (data.class === self.selectedMc.classification) {
                            self.timeHolder.push(Number(data.time))
                            self.initialService.push({
                                jobCode: "",
                                id: result.id,
                                displayName: result.serviceName,
                                displayDescription: result.description,
                                time: data.time,
                                classification: data.class
                            })
                        }
                    })
                })

                self.otherServices.forEach(function (result) {
                    self.timeHolder.push(Number(result.time))
                })

                self.estimateTime =  (self.timeHolder.reduce(function(a, b) { return a + b }, 0))
                self.estimateCharge =  (self.chargeHolder.reduce(function(a, b) { return a + b }, 0))
                let nf = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'Php',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
                nf.format(self.estimateCharge)
                self.estimateCharge = nf.format(self.estimateCharge)
            }
        },
        timeUpdate() {
            let self = this
            let index = []
            let index2 = []
            
            if (self.timeValidation.appointmentTime != "" && self.timeValidation.appointmentTime != null) { 
                index = self.times.indexOf(self.timeValidation.appointmentTime)
                self.removed = self.times.splice(index, self.timeValidation.blockTime)
            }

            if (self.timeValidation2.appointmentTime != "" && self.timeValidation2.appointmentTime != null) { 
                index2 = self.times.indexOf(self.timeValidation2.appointmentTime)
                self.removed = self.times.splice(index2, self.timeValidation2.blockTime)
            }
        },
        async setServiceAppointment(){
            let self = this
            self.timeObtain = []
            await db.collection("ServiceBooking"+self.$stage)
            .where("branchId","==",self.branchId)
            .where("appointmentDate","==",self.calendar)
            .where("status","==","Waiting")
            .where("mechanic","==",self.mechanic)
            .get().then(function(querySnapshot) {
                if (querySnapshot.docs.length > 0) {
                    querySnapshot.forEach(function(res) {
                        res.data().timeHold.forEach(function(data) {
                            self.timeObtain.push(data)
                        })
                    })
                }
            }).then(async function() {
                if (self.timeObtain.includes(self.schedtime)) {
                    self.stopProgress()
                    self.showSnackbarMessage("Time already obtain just now. Please select a new time.", false)
                    setTimeout(() => {
                        self.reload()
                    }, 1000)
                } else {
                    await db.collection("ServiceBooking"+self.$stage).doc(self.id.toString()).set({
                        "motorcycleDetails": self.selectedMc,
                        "userDetails": self.customer,
                        "transactionId": self.id.toString(),
                        "appointmentDate": self.calendar,
                        "appointmentTime": self.schedtime,
                        "branch": self.branch,
                        "branchCode": self.branchCode,
                        "branchId": self.branchId,
                        "initialService": self.initialService,
                        "otherService": self.otherServices,
                        "estimateCharge": self.estimateCharge,
                        "status": "Waiting",
                        "estimateTime": self.estimateTime,
                        "formatedDate": self.computedDateFormattedMomentjs,
                        "timeHold": self.removed,
                        "tag": "No Show",
                        "coupon": self.coupon,
                        "fee": 0,
                        "customerType": "Walk-in",
                        "lastOdo": self.oldOdo,
                        "odometer": self.odometer,
                        "mechanic": self.mechanic,
                        "serving": "0",
                        "remarks": "",
                        "jobType": [],
                        "dateCreated": moment().format('MMMM Do YYYY, h:mm:ss a'),
                        "dateModified": "",
                        "dateApproval": "",
                        "timein": "",
                        "timeout": "",
                    }).then(function(doc) {
                        self.showSnackbarMessage("Appointment saved", true)
                        self.stopProgress()
                        setTimeout(() => {
                            self.reload()
                        }, 500);
                    })   
                }
            })
        },
        async generateId() {
            let self = this
            let list = []
            let splitSeries = null
            let splitYear = null
            let yearSeries = moment().year()
            let strId = "SS-"
            let pad = "00000"
            let getIndex = null
            let str = null
            let ctrlSeries = null
            self.showProgress("Saving Appointment...")
            
            await db.collection("ServiceBooking"+self.$stage).orderBy("transactionId", "desc").limit(1)
            .get().then(async function(snapshot) {
                snapshot.forEach(function(doc) {
                    list.push(doc.id)
                })

                if(list.length < 1) {
                    self.id =  strId + yearSeries + "-" + "00001"
                } else {
                    list.sort(function(a, b){return a-b})
                    splitYear = _.last(list).split("-")[1]

                    if(yearSeries == splitYear) {
                        if(list.length > 0) {
                            getIndex = _.last(list).split("-")[2]
                        } else {
                            getIndex = (Number(list.length - 1) + 1)
                        }
                        str = "" + (Number(getIndex) + 1)
                        ctrlSeries = pad.substring(0, pad.length - str.length) + str
                        self.id = strId + yearSeries + "-" + ctrlSeries
                        
                    } else {
                        str = "" + 1
                        ctrlSeries = pad.substring(0, pad.length - str.length) + str
                        self.id = strId + yearSeries + "-" + ctrlSeries
                    }
                }
                await self.setServiceAppointment()   
            })

            // await db.collection("ServiceBooking"+self.$stage).orderBy("transactionId")
            // .get().then(async function(snapshot) {
            //     snapshot.forEach(function(doc) {
            //         list.push(doc.id)
            //     })

            //     if(list.length < 1) {
            //         self.id =  strId + yearSeries + "-" + "00001"
            //     } else {
            //         list.sort(function(a, b){return a-b})
            //         splitYear = _.last(list).split("-")[1]

            //         if(yearSeries == splitYear) {
            //             if(list.length > 0) {
            //                 getIndex = _.last(list).split("-")[2]
            //             } else {
            //                 getIndex = (Number(list.length - 1) + 1)
            //             }
            //             str = "" + (Number(getIndex) + 1)
            //             ctrlSeries = pad.substring(0, pad.length - str.length) + str
            //             self.id = strId + yearSeries + "-" + ctrlSeries
                        
            //         } else {
            //             str = "" + 1
            //             ctrlSeries = pad.substring(0, pad.length - str.length) + str
            //             self.id = strId + yearSeries + "-" + ctrlSeries
            //         }
            //     }
            //     await self.setServiceAppointment()   
            // })
        },
        goToPage(page) {
            this.$router.push("/"+page)
        },
        mcValidation() {
            let self = this
            if(self.odometer === "" && ( self.mcUnit === null || self.mcUnit === "")) {
                self.showSnackbarMessage("Please select motorcycle and mileage", false)
            } else if (Number(self.oldOdo) > Number(self.odometer)) {
                self.showSnackbarMessage("Mileage should be not less than to your last mileage(km)", false)
            } else {
                self.e1 = 2
            } 
        },
        serviceValidation() {
            let self = this
            if(self.estimateTime < 1) {
                self.showSnackbarMessage("Please select a service", false)
            } else {
                self.e1 = 3
            }
        },
        scheduleValidation() {
            let self = this
            if(self.schedtime == null || self.schedtime == "") {
                self.showSnackbarMessage("Please select a time", false)
            } 
            else {
                self.e1 = 4
            }
        },
        setServices(){
            let self = this
            if(self.initialService.length > 0){
                self.showServices = true
            }
        },
        reload() {
            window.location.reload()
        },
        async calendarValidation() {
            let self = this
            let getEvents = []
            let getLoad = []
            let totalTimeHold = []
            let pivot = null

            await db.collection("Events"+self.$stage)
            .where("branchId","==",self.branchId)
            .where("status","==","approved")
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.lists.push(doc.data())
                })

                self.lists.forEach(function(res) {
                    if (res.timeHold.length > 24) {
                        getEvents.push(res.date)
                        self.arrayEvents.push(res.date)
                    }
                })
            }).then(async function(){
                await db.collection("ServiceBooking"+self.$stage)
                .where("branchId","==",self.branchId)
                .where("status","==","Waiting")
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        getLoad.push(doc.data())
                    })

                    if (getLoad) {
                        pivot = _(getLoad).groupBy('appointmentDate')
                        .map((item, key) => ({
                            appointmentDate: key,
                            timeHold: _.map(item, 'timeHold'),
                            totalTimeHold: _.sumBy(_.map(item, 'timeHold.length'))
                        })).value()

                        pivot.forEach(function(data) {
                            if(data.totalTimeHold > 24) {
                                getEvents.push(data.appointmentDate)
                                self.arrayEvents.push(data.appointmentDate)
                            }
                        })
                    }
                }).then(function(){
                    self.allowedDates = val =>
                    ![0].includes(new Date(val).getDay())&&!getEvents.includes(new Date(val).toISOString().substr(0, 10),)
                })
            })
        },
        async fetchServiceMenu() {
            let self = this
            let services = []
            self.serviceMenu = []   
            await db.collection("ServiceMenu"+self.$stage).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    if (doc.data().status == "active") {
                        self.serviceMenu.push(doc.data())
                    }
                })
            }).then(function(){
                self.serviceMenu.sort()
                self.stopProgress()
            }).catch(function(error){
                self.stopProgress()
                self.showSnackbarMessage("Error fetching document", false)
            })
        },
        async fetchFlatRate() {
            let self = this    
            self.otherTimeRate = []
            let count = 0
            await db.collection("Settings"+self.$stage).doc("FlatRate")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    count ++
                    if (!doc.exists) {
                        self.showSnackbarMessage("Flat Rate should be set", false)
                    } else {
                        self.otherTimeRate.push(doc.data().time)
                    }

                    if (count === querySnapshot.docs.length) {
                        self.otherTimeRate.sort(function(a, b){return a-b})
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Flat Rate should be set", false)
            })
        },
        async fetchMotorcycleDetails() {
            let self = this
            self.mcLists = []
            self.mcOwned = []
            if (self.customer.fullName) {
                await db.collection("McDetails"+self.$stage)
                .where("owner","==",self.customer.fullName)
                .where("status","==","1")
                .get().then(function(querySnapshot){
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach(function(doc){
                            self.mcLists.push(doc.data())
                            self.mcOwned.push(doc.data().model)
                        })
                    } 
                })
            }
        },
        addOtherServices() {
            let self = this 
            self.otherServices.push({
                service: "",
                price: 0,
                time: 0,
            })
        },
        removeOtherService(index) {
            let self = this 
            self.otherServices.splice(index,1)
        },
        async checkMechanics(val) {
            let self = this
            let availableTime = []
            let removedFromDb = []
            let blockTime = 0
            let appointmentTime = ""
            let index = []
            self.schedtime = ""
            self.removed = []
            self.timeValidation = []
            self.timeValidation2 = []
            self.laps = []
            self.showProgress("Loading...")

            if(val) {
                self.schedtime = null
                await db.collection("Mechanics"+self.$stage)
                .where("name","==",val)
                .where("branchId","==",self.branchId)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        self.times = doc.data().time
                    })
                }).then(async function() {
                    await db.collection("ServiceBooking"+self.$stage)
                    .where("branchId","==",self.branchId)
                    .where("appointmentDate","==",self.calendar)
                    .where("status","==","Waiting")
                    .where("mechanic","==",val)
                    .get().then(function(querySnapshot) {
                        if (querySnapshot.docs.length > 0) {
                            querySnapshot.forEach(function(doc) {  
                                self.timeValidation.push({
                                    appointmentTime: doc.data().appointmentTime,
                                    blockTime: doc.data().estimateTime / self.bufferTime
                                })
                            })
                            self.timeValidation.forEach(function(val) {
                                index = self.times.indexOf(val.appointmentTime)
                                removedFromDb = self.times.splice(index, val.blockTime)
                                self.laps.push(removedFromDb)
                            })
                            self.stopProgress()
                        } else {
                            self.timeValidation = {
                                appointmentTime: self.schedtime,
                                blockTime: self.estimateTime / self.bufferTime
                            }
                            self.stopProgress()
                        }
                    })
                })
            }  else {
                self.stopProgress()
            }
        },
        async fetchBrands() {
            let self = this
            self.brands = []
            await db.collection("Settings"+self.$stage).doc("Brands")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.brands.push(doc.data().brand)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },
        async fetchDealers() {
            let self = this
            self.dealers = []
            await db.collection("Settings"+self.$stage).doc("Dealers")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.dealers.push(doc.data().dealer)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },
        async fetchCustomers() {
            let self = this
            self.mcLists = []
            self.mcOwned = []
            self.customers = []
            self.showProgress("Loading...")
            await db.collection("WalkinCustomers"+self.$stage)
            .limit(50)
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.customers.push({
                        address: {
                            brgy: doc.data().address.brgy,
                            city: doc.data().address.city,
                            state: doc.data().address.state
                        },
                        uid: doc.data().uid,
                        email: doc.data().email,
                        mobileNumber: doc.data().mobileNumber,
                        fullName: doc.data().fullName,
                        firstName: doc.data().firstName,
                        lastName: doc.data().lastName,
                        status: "from Walk-in",
                        transactionId: ""
                    })
                })
            }).then(function(){
                self.stopProgress()
            })
        },
        async searchCustomer(fullName){
            let self = this
            self.customers = []
            self.showProgress("Loading...")
            if(fullName) {
                await self.searchToLowerCase(fullName).then(function() {self.stopProgress()})
                await self.searchToUpperCase(fullName).then(function() {self.stopProgress()})
                await self.searchToCapitalize(fullName).then(function() {self.stopProgress()})
            } else {
                self.fetchCustomers()
            }
        },
        async searchToLowerCase(fullName){
            let self = this
            self.mcLists = []
            self.mcOwned = []
            let ssCustomer = []
            await db.collection("WalkinCustomers"+self.$stage)
            .where("fullName","==",fullName.toLowerCase())
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.customers.push({
                        address: {
                            brgy: doc.data().address.brgy,
                            city: doc.data().address.city,
                            state: doc.data().address.state
                        },
                        uid: doc.data().uid,
                        email: doc.data().email,
                        mobileNumber: doc.data().mobileNumber,
                        fullName: doc.data().fullName,
                        firstName: doc.data().firstName,
                        lastName: doc.data().lastName,
                        status: "from Walk-in",
                        transactionId: ""
                    })
                })
            })

            await db.collection("ServiceBooking"+self.$stage)
            .where("customerType","==","Self-Service")
            .where("tag","==","Show")
            .where("status","==","Completed")
            .where("fullName","==",fullName.toLowerCase())
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (doc.data().userDetails.uid != null) {
                        ssCustomer.push(doc.data().userDetails.uid)
                    }
                })
            }).then(function(){
                ssCustomer = _.uniqBy(ssCustomer)
            }).then(function(){
                if (ssCustomer.length > 0) {
                    ssCustomer.forEach(function(res){
                        db.collection("Users"+self.$stage).doc(res).get()
                        .then(function(data){
                            if (data.exists) {
                                self.customers.push({
                                    address: {
                                        brgy: data.data().address.brgy,
                                        city: data.data().address.city,
                                        state: data.data().address.state
                                    },
                                    uid: data.data().uid,
                                    email: data.data().email,
                                    mobileNumber: data.data().mobileNumber,
                                    fullName: data.data().fullName,
                                    firstName: data.data().firstName,
                                    lastName: data.data().lastName,
                                    status: "from Self-Service",
                                    transactionId: ""
                                })
                            }
                        })
                    })
                }
            })
        },
        async searchToUpperCase(fullName){
            let self = this
            self.mcLists = []
            self.mcOwned = []
            let ssCustomer = []
            await db.collection("WalkinCustomers"+self.$stage)
            .where("fullName","==",fullName.toUpperCase())
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.customers.push({
                        address: {
                            brgy: doc.data().address.brgy,
                            city: doc.data().address.city,
                            state: doc.data().address.state
                        },
                        uid: doc.data().uid,
                        email: doc.data().email,
                        mobileNumber: doc.data().mobileNumber,
                        fullName: doc.data().fullName,
                        firstName: doc.data().firstName,
                        lastName: doc.data().lastName,
                        status: "from Walk-in",
                        transactionId: ""
                    })
                })
            })

            await db.collection("ServiceBooking"+self.$stage)
            .where("customerType","==","Self-Service")
            .where("tag","==","Show")
            .where("status","==","Completed")
            .where("fullName","==",fullName.toUpperCase())
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (doc.data().userDetails.uid != null) {
                        ssCustomer.push(doc.data().userDetails.uid)
                    }
                })
            }).then(function(){
                ssCustomer = _.uniqBy(ssCustomer)
            }).then(function(){
                if (ssCustomer.length > 0) {
                    ssCustomer.forEach(function(res){
                        db.collection("Users"+self.$stage).doc(res).get()
                        .then(function(data){
                            if (data.exists) {
                                self.customers.push({
                                    address: {
                                        brgy: data.data().address.brgy,
                                        city: data.data().address.city,
                                        state: data.data().address.state
                                    },
                                    uid: data.data().uid,
                                    email: data.data().email,
                                    mobileNumber: data.data().mobileNumber,
                                    fullName: data.data().fullName,
                                    firstName: data.data().firstName,
                                    lastName: data.data().lastName,
                                    status: "from Self-Service",
                                    transactionId: ""
                                })
                            }
                        })
                    })
                }
            })
        },
        async searchToCapitalize(fullName){
            let self = this
            self.mcLists = []
            self.mcOwned = []
            let ssCustomer = []
            self.capitalize(fullName)
            await db.collection("WalkinCustomers"+self.$stage)
            .where("fullName","==",self.capitalize(fullName))
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.customers.push({
                        address: {
                            brgy: doc.data().address.brgy,
                            city: doc.data().address.city,
                            state: doc.data().address.state
                        },
                        uid: doc.data().uid,
                        email: doc.data().email,
                        mobileNumber: doc.data().mobileNumber,
                        fullName: doc.data().fullName,
                        firstName: doc.data().firstName,
                        lastName: doc.data().lastName,
                        status: "from Walk-in",
                        transactionId: ""
                    })
                })
            })

            await db.collection("ServiceBooking"+self.$stage)
            .where("customerType","==","Self-Service")
            .where("tag","==","Show")
            .where("status","==","Completed")
            .where("fullName","==",self.capitalize(fullName))
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (doc.data().userDetails.uid != null) {
                        ssCustomer.push(doc.data().userDetails.uid)
                    }
                })
            }).then(function(){
                ssCustomer = _.uniqBy(ssCustomer)
            }).then(function(){
                if (ssCustomer.length > 0) {
                    ssCustomer.forEach(function(res){
                        db.collection("Users"+self.$stage).doc(res).get()
                        .then(function(data){
                            if (data.exists) {
                                self.customers.push({
                                    address: {
                                        brgy: data.data().address.brgy,
                                        city: data.data().address.city,
                                        state: data.data().address.state
                                    },
                                    uid: data.data().uid,
                                    email: data.data().email,
                                    mobileNumber: data.data().mobileNumber,
                                    fullName: data.data().fullName,
                                    firstName: data.data().firstName,
                                    lastName: data.data().lastName,
                                    status: "from Self-Service",
                                    transactionId: ""
                                })
                            }
                        })
                    })
                }
            })
        },
        capitalize(fullName) {
            var separateName = fullName.toLowerCase().split(' ');
            for (var i = 0; i < separateName.length; i++) {
                separateName[i] = separateName[i].charAt(0).toUpperCase() +
                separateName[i].substring(1);
            }
            return separateName.join(' ');
        },
        selectedCustomer(details) {
            let self = this
            self.customer = details
            self.fetchMotorcycleDetails()
        }
    },
    async mounted() {
        let self = this
        await self.getAssign()
        await self.fetchClassification()
        await self.fetchBufferTime()
        await self.fetchDealers()
        await self.fetchBrands()
        await self.fetchServiceMenu()
        await self.fetchTimeSchedule()
        await self.fetchCustomers()
        await self.fetchFlatRate()
    },

    computed: {
         computedDateFormattedMomentjs () {
                return this.calendar ? moment(this.calendar).format('dddd, MMMM Do YYYY') : ''
            },
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {
        yearModelMenu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))

        },
        yearModel (val) {
            let self = this
            if (val !== ""){
                self.yearModel = val.split('-')[0].trim()
            }
        },

        selected: {
           handler: function(newValue) {
                this.chargeEstimate()
           },
           deep: true
        },

        otherServices: {
           handler: function(oldVal, newValue) {
                this.chargeEstimate()
           },
           deep: true
        },

        mcUnit: function(val) {
            let self = this
            let process = 0

            if(self.mcLists){
                let list = _.filter(self.mcLists, item => item.model === self.mcUnit)
                list.forEach(function(res) {
                    self.oldOdo = res.odometer
                    self.selectedMc = res
                })
            }
            self.odometer = ""
        },

        calendar: function(val) {
            let self = this
            let availableTime = []
            let adminTime = []
            let adminTimeProcess = 0
            self.schedtime = null
            self.times = []

            if (self.mechanics.length === 1) {
                self.mechanic = self.mechanics[0]
            } else {
                self.mechanic = ""
            }

            db.collection("Events"+self.$stage)
                .where("branchId","==",self.branchId)
                .where("status","==","approved")
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        adminTime.push(doc.data())
                        adminTimeProcess ++
                    })
                }).then(function() {
                    if(adminTimeProcess === adminTime.length) {
                        adminTime.forEach(function(res) {
                            if(res.date == self.calendar) {
                                availableTime=res
                            }
                        })
                        try {
                            if( self.calendar != ""){
                                self.times = self.times.filter(value => !availableTime.timeHold.includes(value))
                            }
                        } catch(err) {}
                    }
                }).then(function(){
                    self.calendarValidation()
                    self.checkMechanics(self.mechanic)
                })
        },

        schedtime: function(val) {
            let self = this
            let index2 = []
            let lapsChecker = []
            self.timeRemoveHolder = []

            self.timeValidation2 = {
                appointmentTime: self.schedtime,
                blockTime: self.estimateTime / self.bufferTime
            }
            
            if(self.timeValidation2.appointmentTime != "" && self.timeValidation2.appointmentTime != null){      
                index2 = self.timesChecker.indexOf(self.timeValidation2.appointmentTime)
                self.timeRemoveHolder = self.timesChecker.splice(index2, self.timeValidation2.blockTime)
                self.laps = [].concat.apply([], self.laps)

                self.timeRemoveHolder.forEach(function(doc) {
                    if(self.laps.includes(doc)) {
                        lapsChecker.push(doc)
                    }
                })
                
                if(lapsChecker.length > 0) {
                    self.fetchTimeSchedule()
                    self.showSnackbarMessage("Cannot accomodate service in your selected hours. Please select another time", false)
                    setTimeout(() => {
                        index2 = []
                        lapsChecker = []
                        self.timeRemoveHolder = []
                        self.schedtime = null
                    }, 500)
                }
            }
        },
        
        mechanic: function(val) {
            this.checkMechanics(val)
        },
    }
}

</script>

<style scoped>

</style>
